import styled from "styled-components";

export const Container = styled.div`
  display: none;

  @media (max-width: 999px) {
    display: block;
    margin-top: 7rem;
    text-align: center;
    max-width: 90%;
    justify-content: center;
    align-items: center;
    margin-right: auto;
    font-family: "Poppins", sans-serif;
    color: #777474;
    margin-left: auto;
    .button-mobile {
      width: 18rem;
      padding: 0.7rem;
      border-radius: 1.6rem;
      background: #0d6efd;
      color: #fff;
      border: none;
      font-family: "Poppins", sans-serif;
      margin-top: 0.3rem;
      z-index: 9;
      justify-content: start;
      margin-bottom: 0.5rem;
      cursor: pointer;
      transition: all 0.4s;
    }
    .button-mobile:hover {
      transform: scale(1.1);
    }
    .banner-p-mobile {
      color: #777474;
      font-size: 1.2rem;
      margin-top: 5.4rem;
      margin-bottom: 2rem;
      text-align: center;
      font-family: "Poppins", sans-serif;
      margin-left: 0.1rem;
    }
  }
`;
